import React, { PureComponent } from 'react';
import { Table, Icon, Modal, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import format from '../../shared/format';
import renderEnhancer from '../../shared/renderEnhancer';
import cellRenderEnhancer, { beforeChangeEnhancer } from '../../shared/cellRenderEnhancer';
import { queryInvestigationStage } from '../../common/queryInvestigationStage';
import genOperationAuth from '../../common/genOperationAuth';
import { Default } from './constants';

class Present extends PureComponent {
    constructor(props) {
        super(props);
        this.queryInvestigationStage = queryInvestigationStage.bind(this);
        this.state = {
            data: [],
            loading: false,
            pagination: {
                pageSize: 1,
                current: 1,
            },
            isMainPM: false,
            expandedRowKeys: [],
            childJdeContractList: [],
            showAllColumns: false,  // 新增：控制是否显示全部字段
            isBoTal: false,         // 是否是BO或领域leader
        };
    }

    componentDidMount() {
        this.loadData();
    }

    queryMainPM = (id) => {
        this.setState({ loading: true });
        const options = {
            url: API_URL.contract.queryContractRemittanceNodes,
            data: {investigationJdeContractId:id},
            dataType: 'json',
            doneResult: res => {
                const { isMainPM } = res;
                this.setState({ isMainPM, loading: false})
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.reload !== this.props.reload) {
            const { pagination } = this.state;
            this.setState({ pagination: {
                ...pagination,
                // current: 1
            }}, () => {
                this.loadData();
            });
        }
    }

    search = () => {
        const { pagination } = this.state;
            this.setState({ pagination: {
                ...pagination,
                current: 1
            }}, () => {
                this.loadData();
            });
    }

    loadData = () => {
        const { searchParams, canUpload } = this.props;
        const { pagination, expandedRowKeys } = this.state;
        const { current } = pagination;
        this.setState({ loading: true });
        const options = {
            url: API_URL.investigation.queryAllJde,
            data: {
                offset: current,
                ...searchParams,
                limit: 1,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas: data, totalCount, data:{ upload } } = res;
                pagination.total = totalCount;
                const [ { investigationName, isInvCsa, mainInvestigationJdeContractCode, childJdeContractList, judgeDeptBo, judgeTal, stageNames } = {} ] = data || [];
                expandedRowKeys[0] = mainInvestigationJdeContractCode;
                (childJdeContractList || []).forEach(i => i.investigationName = investigationName);
                (childJdeContractList || []).forEach(i => i.isInvCsa = isInvCsa);
                (childJdeContractList || []).length && this.queryMainPM(childJdeContractList[0].investigationJdeContractId)
                canUpload(upload)
                const isBoTal = (judgeDeptBo || judgeTal) && stageNames !== '项目关闭';
                this.setState({
                    canUpload: upload,
                    loading: false,
                    data: data || [],
                    childJdeContractList,
                    expandedRowKeys,
                    pagination,
                    isBoTal,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    handleAddTabe = () => {
        this.setState(prevState => ({
            showAllColumns: !prevState.showAllColumns  // 切换显示状态
        }), () => {
            // 刷新表格（如果需要）
            this.loadData();
        });
    };

    setTipTittle = (text) => {
        if (!text) {
            return ''
        }
        const arr = (text || "").split("\\n");
        const tipTitle = (
            <div>
                {arr.map(el => (
                    <span>
                        {el}
                        <br />
                    </span>
                ))}
            </div>
        );
        return tipTitle
    }


    getColumns = () => {
        const { curRole } = sessionStorage;
        // 定义所有列（保持原有完整列配置）
        const allColumns = [{
            title: (
                <span>
                    JDE主项目号
                    <Icon 
                        type={this.state.showAllColumns ? 'minus-square-o' : 'plus-square-o'}  // 根据状态切换图标
                        style={{ marginLeft: 5, cursor: 'pointer', marginTop: 5 }} 
                        onClick={this.handleAddTabe} 
                    />
                </span>
            ),
            dataIndex: 'mainInvestigationJdeContractCode',
            key: 'mainInvestigationJdeContractCode',
            width: 100,
            render: renderEnhancer((text, record, index) => {
                if (record.fileCount) {
                    return <span>{text}<Icon type="paper-clip" style={{color: '#ffbf00', cursor: 'pointer'}} onClick={() => this.props.showAttachment(record, 'mainInvestigationJdeContractCode')}/></span>;
                }
                return text;
            }),
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 100,
            render: (text, record) => {
                const { progressStatus } = record;
                return progressStatus === 'ENDED' ? <a onClick={()=>this.showProjectClose(record, 'view')}>{text}</a> : text
            }
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            width: 90,
        }, {
            title: '项目阶段',
            dataIndex: 'stageNames',
            key: 'stageNames',
            width: 90,
        }, {
            title: '研究产品类型',
            dataIndex: 'investigationMedicineTypeShow',
            key: 'investigationMedicineTypeShow',
            width: 90,
        }, 
        // {
        //     title: '项目分期',
        //     dataIndex: 'investigationByStageName',
        //     key: 'investigationByStageName',
        // }, {
        //     title: '受试者类型',
        //     dataIndex: 'testeeTypeName',
        //     key: 'testeeTypeName',
        // }, {
        //     title: '项目分类',
        //     dataIndex: 'investigationType',
        //     key: 'investigationType',
        // }, 
        {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 80,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 80,
        }, {
            title: '计收入确认方式',
            dataIndex: 'contractTypeValue',
            key: 'contractTypeValue',
            width: 80,
        }, {
            title: '合同额含税/人民币(元)',
            dataIndex: 'jdeContractAmountShow',
            key: 'jdeContractAmountShow',
            render: text => format('money', text),
            width: 100,
        }, {
            title: '申办方',
            dataIndex: 'investigationSponsor',
            key: 'investigationSponsor',
            width: 80,
        }, {
            title: 'PM工号',
            dataIndex: 'pmEmployeeCode',
            key: 'pmEmployeeCode',
            width: 80,
        }, {
            title: 'PM姓名',
            dataIndex: 'pmUserCompellation',
            key: 'pmUserCompellation',
            width: 80,
        }, 
        // {
        //     title: 'BD工号',
        //     dataIndex: 'bdEmployeeCode',
        //     key: 'bdEmployeeCode',
        // }, {
        //     title: 'BD姓名',
        //     dataIndex: 'bdUserCompellation',
        //     key: 'bdUserCompellation',
        // }, 
        {
            title: 'CSA工号',
            dataIndex: 'csaEmployeeCode',
            key: 'csaEmployeeCode',
            width: 80,
        }, {
            title: 'CSA姓名',
            dataIndex: 'csaUserCompellation',
            key: 'csaUserCompellation',
            width: 80,
        }, 
        // {
        //     title: 'BA工号',
        //     dataIndex: 'baCode',
        //     key: 'baCode',
        // }, {
        //     title: 'BA姓名',
        //     dataIndex: 'baName',
        //     key: 'baName',
        // }, 
        {
            title: '项目关闭申请情况',
            dataIndex: 'invRemittanceCompletedInfoShow',
            key: 'invRemittanceCompletedInfoShow',
            width: 100,
            // render: cellRenderEnhancer({
            //     renderContent: record => {
            //         const { remittanceCompletedInfoShow: status, pmConfirmUserName, pmConfirmEmployeeCode, finConfirmUserName, finConfirmEmployeeCode, invCloseApplyAuditInfo } = record;
            //         if (status === '待FIN确认' || status === 'FIN拒绝确认' || status === 'FIN已确认') {
            //             return (
            //                 <div>
            //                     {`PM确认: ${pmConfirmUserName}[${pmConfirmEmployeeCode}]`}
            //                     <br />
            //                     {status === 'FIN已确认' && `FIN确认: ${finConfirmUserName}[${finConfirmEmployeeCode}]`}
            //                 </div>
            //             );
            //         }
            //     }
            // })(),
            render: cellRenderEnhancer({
                renderContent: record => {
                    const { invCloseApplyAuditInfo } = record;
                    const invCloseApplyAuditInfoShow = this.setTipTittle(invCloseApplyAuditInfo)
                    return invCloseApplyAuditInfoShow
                }
            })(),
        }, {
            title: '项目财务数据调整情况',
            dataIndex: 'adjustStatusShow',
            key: 'adjustStatusShow',
            width: 100,
        }, {
            title: '项目关闭时间',
            dataIndex: 'invCloseDate',
            key: 'invCloseDate',
            width: 100,
        }, {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: 80,
            render: (text, record) => {
                const { 
                    remittanceCompletedInfoShow: status, 
                    investigationId, 
                    isCanCompleted,
                    curUserIsPm, 
                    startFinancialAdjustFlag,
                    approvalFinancialAdjustFlag,
                    restartFinancialAdjustFlag,
                    judgeMainPm,
                    progressStatus,
                    canCloseInv,
                    invCloseApplyStatus,
                    invRemittanceCompletedInfo,
                    canAuditInvClose,
                    stageNames,
                } = record;
                const openFinanceType = restartFinancialAdjustFlag ? 'reOpenFinance' : 'openFinance';
                
                const operationCorrespondRoles = new Map([
                    // ['apply', {
                    //     name: '申请项目请款完成',
                    //     display: true,
                    //     editable: isCanCompleted == 1 && (status === '未确认' || status === 'PM拒绝确认' || status === 'FIN拒绝确认'),
                    //     event: () => this.queryInvestigationStage(investigationId, () => this.applyProjectFinish(record, 'BA'), ['INVESTIGATION_DATA_LOCK']),
                    //     roles: ['CSA', 'CSAL'],
                    // }],
                    ['openFinance', {
                        name: '开启财务数据调整',
                        display: startFinancialAdjustFlag || restartFinancialAdjustFlag,
                        // display: true,
                        editable: true,
                        event: () => this.props.showFinanceAdjust(record, openFinanceType),
                        roles: ['*'],
                    }],
                    ['approvalFinance', {
                        name: '审批财务数据调整',
                        display: approvalFinancialAdjustFlag,
                        // display: true,
                        editable: true,
                        event: () => this.props.showFinanceAdjust(record, 'approvalFinance'),
                        roles: ['*'],
                    }],
                    ['apply', {
                        name: '项目关闭申请',
                        // display: judgeMainPm && ((invCloseApplyStatus == null || invCloseApplyStatus == '' || invCloseApplyStatus == undefined || invCloseApplyStatus == 'CHARGE_USER_REJECT' || invCloseApplyStatus == 'FIN_REJECT') || (stageNames == '业务数据归档' && progressStatus == 'ENDED')),
                        display: judgeMainPm && !(invCloseApplyStatus == 'TO_BE_CHARGE_USER_CONFIRM' || invCloseApplyStatus == 'TO_BE_FIN_CONFIRM'),
                        editable: true,
                        event: () => this.showProjectClose(record, 'apply'),
                        roles: ['*'],
                    }],
                    ['approval', {
                        name: '确认项目关闭',
                        display: (invRemittanceCompletedInfo == 'TO_BE_CHARGE_USER_CONFIRM' || invRemittanceCompletedInfo == 'TO_BE_FIN_CONFIRM') && canAuditInvClose,
                        // display: true,
                        editable: true,
                        event: () => this.showProjectClose(record, 'approval'),
                        roles: ['*'],
                    }],
                    // ['confirm', {
                    //     name: '确认项目请款完成',
                    //     display: true,
                    //     editable: (status === '待PM确认' && (curRole === 'PM' || curUserIsPm)) || (status === '待FIN确认' && curRole === 'FIN'),
                    //     event: () => this.queryInvestigationStage(investigationId, () => this.applyProjectFinish(record, curRole), ['INVESTIGATION_DATA_LOCK']),
                    //     roles: ['PM', 'FIN','CRC','CRCC','CRCM'],
                    // }],
                    ['log', {
                        name: '操作日志',
                        display: true,
                        editable: true,
                        event: () => this.props.showLog(record, 'INVESTIGATION_REMITTANCE_LOG'),
                        roles: ['*'],
                    }],
                ]);
                return genOperationAuth(operationCorrespondRoles, curRole);
            }
        }];

        const defaultColumnKeys = [
            'mainInvestigationJdeContractCode',  // JDE主项目号
            'investigationName',                 // 项目简称
            'stageNames',                        // 项目阶段
            'investigationMedicineTypeShow',     // 研究产品类型
            'investigationAreaName',             // 项目领域
            'diseaseName',                       // 疾病
            'jdeContractAmountShow',             // 合同额含税/人民币(元)
            'pmEmployeeCode',                    // PM工号
            'pmUserCompellation',                // PM姓名
            'csaEmployeeCode',                   // CSA工号
            'csaUserCompellation',               // CSA姓名
            'remittanceCompletedInfoShow',       // 项目关闭申请情况
            'adjustStatusShow',                  //项目财务数据调整情况
            'invCloseDate',                      //项目关闭时间
            'invRemittanceCompletedInfoShow',    //项目关闭申请情况
            'operation',                         //操作
        ];
    
        // 根据状态过滤显示的列
        return this.state.showAllColumns 
            ? allColumns  // 显示全部列
            : allColumns.filter(column => defaultColumnKeys.includes(column.key));  // 只显示默认列
    };
    
    handleTableChange = (pagination, filters, sorter) => {
        const pager = { ...this.state.pagination };
        if (pager.current == pagination.current){
            pager.current = 1;
        } else {
            pager.current = pagination.current;
        }
        this.setState({
            pagination: pager,
        }, () => {
            this.loadData();
        });
    }

    expandedRowRender = () => {
        const { curRole } = sessionStorage;

        const getColumns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 60,
            fixed: 'left',
            render: renderEnhancer(),
        }, {
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            width: 120,
            fixed: 'left',
            render: renderEnhancer((text, record, index) => {
                if (record.fileCount) {
                    return <span>{text}<Icon type="paper-clip" style={{color: '#ffbf00', cursor: 'pointer'}} onClick={() => this.props.showAttachment(record, 'investigationJdeContractCode')}/></span>;
                }
                return text;
            }),
        }, {
            title: '合同主键',
            dataIndex: 'investigationJdeContractId',
            key: 'investigationJdeContractId',
            width: 100,
            render: renderEnhancer(),
        }, {
            title: '名称(ProjectID)',
            dataIndex: 'projectIdName',
            key: 'projectIdName',
            width: 100,
            render: renderEnhancer(),
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 80,
            render: renderEnhancer(),
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineNames',
            key: 'secondLineNames',
            width: 80,
            render: renderEnhancer(),
        }, {
            title: '类别码13',
            dataIndex: 'categoryCodeName13',
            key: 'categoryCodeName13',
            width: 80,
            render: renderEnhancer((text, record, index) => {
                return <span style={{ color: record.categoryCodeStatus == 1 && 'red' }}>{text}</span>;
            }),
        }, {
            title: '合同签署单位',
            dataIndex: 'signingUnit',
            key: 'signingUnit',
            width: 100,
            render: renderEnhancer(),
        }, {
            title: '收入归属单位',
            dataIndex: 'belongingToUnit',
            key: 'belongingToUnit',
            width: 100,
            render: renderEnhancer(),
        }, {
            title: '客户全名',
            dataIndex: 'customerCompanyName',
            key: 'customerCompanyName',
            width: 100,
            render: renderEnhancer(),
        }, {
            title: '客户JDE号',
            dataIndex: 'customerJdeCode',
            key: 'customerJdeCode',
            width: 100,
            render: renderEnhancer(),
        }, 
        // {
        //     title: 'BA工号',
        //     dataIndex: 'baCode',
        //     key: 'baCode',
        //     width: 80,
        //     render: renderEnhancer(),
        // }, 
        {
            title: '合同BA',
            dataIndex: 'baName',
            key: 'baName',
            width: 80,
            render: renderEnhancer((text , row) => {
                return row.baWorkStatus == 'LEFT' ? <span style={{ color: '#999999' }}>{text}</span> : text; 
            }),
        },
        {
            title: '客户BA',
            dataIndex: 'baNameCode',
            key: 'baNameCode',
            width: 80,
            render: renderEnhancer((text , row) => {
                return (
                (row.baList || []).map((item, index, arr) => {
                    const { userId, userCompellation, workStatus } = item;
                    return <span key={userId} style={{ color:workStatus == 'LEFT'?'#999999':undefined }}>{userCompellation}{index < arr.length - 1 && '；'}{(index + 1) % 2 === 0 && <br />}</span>;
                })
                )
            }),
        }, 
        {
            title: '客户CSA',
            dataIndex: 'csaNameCode',
            key: 'csaNameCode',
            width: 80,
            render: renderEnhancer((text , row) => {
                return (
                (row.csaList || []).map((item, index, arr) => {
                    const { userId, employeeCode, userCompellation, workStatus } = item;
                    return <span key={userId} style={{ color:workStatus == 'LEFT'?'#999999':undefined }}>{userCompellation}[{employeeCode}]{index < arr.length - 1 && '；'}{(index + 1) % 2 === 0 && <br />}</span>;
                })
                )
            }),
        }, {
            title: '计收入确认方式',
            dataIndex: 'contractTypeValue',
            key: 'contractTypeValue',
            width: 70,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: beforeChangeEnhancer((record) => record['oldContractTypeValue'])
                })()
            ),
        }, {
            title: '发票税率',
            dataIndex: 'invoiceRate',
            key: 'invoiceRate',
            width: 70,
            render: renderEnhancer(text => format('unit', text, '%')),
        }, {
            title: '是否据实结算',
            dataIndex: 'isRealitySettle',
            key: 'isRealitySettle',
            width: 100,
            render: renderEnhancer((text , row) => {
                const { investigationJdeContractIsSigned } = row;
                return investigationJdeContractIsSigned == 1 ?Default[text]:'';
            }),
        }, {
            title: '客户是否MSA特殊优惠客户',
            dataIndex: 'isMsaSpecialDiscountCustom',
            key: 'isMsaSpecialDiscountCustom',
            width: 100,
            render: renderEnhancer((text , row) => {
                const { isDiscountTermValidity ,investigationJdeContractIsSigned } = row;
                return investigationJdeContractIsSigned == 1?isDiscountTermValidity == 1?'是':Default[text]:'';
            }),
        }, {
            title: '是否在优惠有效期内',
            dataIndex: 'isDiscountTermValidity',
            key: 'isDiscountTermValidity',
            width: 100,
            render: renderEnhancer((text , row) =>{
                const {investigationJdeContractIsSigned } = row;
                return investigationJdeContractIsSigned == 1?Default[text]:''
            }),
            
        }, {
            title: 'MSA特殊优惠是否从合同额中扣减',
            dataIndex: 'isMsaSpecialContractReduce',
            key: 'isMsaSpecialContractReduce',
            width: 100,
            render: renderEnhancer((text , row) => {
                const { investigationJdeContractIsSigned } = row;
                return investigationJdeContractIsSigned == 1 ?Default[text]:'';
            }),
        }, {
            title: '优惠金额（含税）/人民币',
            dataIndex: 'discountContractAmount',
            key: 'discountContractAmount',
            width: 100,
            render: renderEnhancer((text , row) => {
                const { investigationJdeContractIsSigned } = row;
                return investigationJdeContractIsSigned == 1 ?text:'';
            }),
        }, {
            title: '优惠金额（不含税）/人民币',
            dataIndex: 'discountContractAmountNoTax',
            key: 'discountContractAmountNoTax',
            width: 100,
            render: renderEnhancer((text , row) => {
                const { investigationJdeContractIsSigned } = row;
                return investigationJdeContractIsSigned == 1 ?text:'';
            }),
        }, {
            title: '合同是否签署完成',
            dataIndex: 'investigationJdeContractIsSigned',
            key: 'investigationJdeContractIsSigned',
            width: 70,
            render: renderEnhancer(text => Default[text]),
        }, {
            title: '合同中是否明标合同金额',
            dataIndex: 'investigationJdeContractIsSpecifiesAmount',
            key: 'investigationJdeContractIsSpecifiesAmount',
            width: 90,
            render: renderEnhancer(text => Default[text]),
        }, {
            title: '币种',
            dataIndex: 'currency',
            key: 'currency',
            width: 90,
            render: renderEnhancer(),
        }, {
            title: '汇率',
            dataIndex: 'exchangeRate',
            key: 'exchangeRate',
            width: 80,
            render: renderEnhancer(text => (text || text === 0) ? text : ''),
        }, {
            title: '合同额含税/原币',
            dataIndex: 'initialContractAmountShow',
            key: 'initialContractAmountShow',
            width: 100,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const { initialActualExpenseFee, initialTaxationFee, initialActualFee } = record;
                        if (initialActualExpenseFee || initialActualExpenseFee === 0 || initialActualFee || initialActualFee === 0 || initialTaxationFee || initialTaxationFee === 0) {
                            return (
                                <div>
                                    {(initialActualExpenseFee || initialActualExpenseFee === 0) && <span>{`实报实销(不含税)/原币: ${format('money', initialActualExpenseFee)}`}<br/></span>}
                                    {(initialActualFee || initialActualFee === 0) && <span>{`实报实销税费/原币: ${format('money', initialActualFee)}`}<br/></span>}
                                    {(initialTaxationFee || initialTaxationFee === 0) && <span>{`合同额税费/原币: ${format('money', initialTaxationFee)}`}<br/></span>}
                                </div>
                            );
                        }
                    }
                })(text => format('money', text))
            ),
        }, {
            title: '合同额含税/人民币(元)',
            dataIndex: 'jdeContractAmountShow',
            key: 'jdeContractAmountShow',
            width: 100,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const { actualExpenseFeeShow, taxationFeeShow, actualFeeShow } = record;
                        if (actualExpenseFeeShow || actualExpenseFeeShow === 0 || taxationFeeShow || taxationFeeShow === 0 || actualFeeShow || actualFeeShow === 0) {
                            return (
                                <div>
                                    {(actualExpenseFeeShow || actualExpenseFeeShow === 0) ? <span>{`实报实销(不含税)/人民币: ${format('money', actualExpenseFeeShow)}`}<br/></span>: null}
                                    {(actualFeeShow || actualFeeShow === 0) ? <span>{`实报实销税费/人民币: ${format('money', actualFeeShow)}`}<br/></span>: null}
                                    {(taxationFeeShow || taxationFeeShow === 0) ? <span>{`合同额税费/人民币: ${format('money', taxationFeeShow)}`}<br/></span>: null}
                                </div>
                            );
                        }
                    }
                })(text => format('money', text))
            ),
        }, {
            title: '合同税率',
            dataIndex: 'rate',
            key: 'rate',
            width: 70,
            render: renderEnhancer(text => format('unit', text, '%')),
        }, {
            title: '合同新增时间',
            dataIndex: 'createTime',
            key: 'createTime',
            width: 90,
            render: renderEnhancer(value => format('date', value)),
        }, {
            title: '合同开始时间',
            dataIndex: 'startTimeShow',
            key: 'startTimeShow',
            width: 90,
            render: renderEnhancer(),
        }, {
            title: '合同结束时间',
            dataIndex: 'endTimeShow',
            key: 'endTimeShow',
            width: 90,
            render: renderEnhancer(),
        }, {
            title: '合同性质',
            dataIndex: 'contractNatureShow',
            key: 'contractNatureShow',
            width: 90,
            render: renderEnhancer(),
        }, {
            title: '关联JDE',
            dataIndex: 'relationContractCode',
            key: 'relationContractCode',
            width: 100,
            render: renderEnhancer(),
        }, {
            title: '备注',
            dataIndex: 'comments',
            key: 'comments',
            width: 140,
            render: renderEnhancer(),
        }, {
            title: '涉及中心',
            dataIndex: 'jdeSiteInfo',
            key: 'jdeSiteInfo',
            width: 120,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {jdeSiteTips } = record;
                        const jdeSiteTipsList = jdeSiteTips?jdeSiteTips.split(';'):[]
                        if ((jdeSiteTipsList || []).length > 1) {
                            return (
                                <div>
                                    {
                                        jdeSiteTipsList.map((value,index) => (
                                            <div key={index}>
                                                {value} 
                                            </div>
                                        ))
                                    }
                                </div>
                            );
                        }
                    }
                })()
            ),
        }, {
            title: 'FTE单价(含税)(元)',
            dataIndex: 'fteUnitPrice',
            key: 'fteUnitPrice',
            width: 80,
            render: renderEnhancer(),
        }, 
        // {
        //     title: '合同请款完成情况',
        //     dataIndex: 'remittanceCompletedInfoShow',
        //     key: 'remittanceCompletedInfoShow',
        //     render: renderEnhancer(
        //         cellRenderEnhancer({
        //             renderContent: record => {
        //                 const { remittanceCompletedInfoShow: status, pmConfirmUserName, pmConfirmEmployeeCode, finConfirmUserName, finConfirmEmployeeCode } = record;
        //                 if (status === '待FIN确认' || status === 'FIN拒绝确认' || status === 'FIN已确认') {
        //                     return (
        //                         <div>
        //                             {`PM确认: ${pmConfirmUserName}[${pmConfirmEmployeeCode}]`}
        //                             <br />
        //                             {status === 'FIN已确认' && `FIN确认: ${finConfirmUserName}[${finConfirmEmployeeCode}]`}
        //                         </div>
        //                     );
        //                 }
        //             }
        //         })()
        //     ),
        // }, 
        {
            title: '操作',
            dataIndex: 'operation',
            width: 150,
            fixed: 'right',
            key: 'operation',
            render: renderEnhancer((value, record) => {
                const { remittanceCompletedInfoShow: status, isPaymentProgress, investigationId, isContrary,curUserIsPm, jdeContractAmount, investigationJdeContractCode, setNoPaymentRequest } = record;
                const { isBoTal } = this.state;
                if(!investigationJdeContractCode) return null;
                const { curRole } = sessionStorage;
                const { isMainPM } = this.state;
                const operationCorrespondRoles = new Map([
                    // ['apply', {
                    //     name: '申请合同请款完成',
                    //     display: isContrary != 1 && jdeContractAmount !== null && jdeContractAmount !== 0,
                    //     editable: isPaymentProgress == 1 && (status === '未确认' || status === 'PM拒绝确认' || status === 'FIN拒绝确认'),
                    //     event: () => this.queryInvestigationStage(investigationId, () => this.applyContractFinish(record, 'BA'), ['INVESTIGATION_DATA_LOCK']),
                    //     roles: ['CSA', 'CSAL'],
                    // }],
                    // ['confirm', {
                    //     name: '确认合同请款完成',
                    //     display: isContrary != 1 && (status === '待PM确认' && curUserIsPm || status === '待FIN确认' && curRole === 'FIN'),
                    //     editable: true,
                    //     event: () => this.queryInvestigationStage(investigationId, () => this.applyContractFinish(record, curRole), ['INVESTIGATION_DATA_LOCK']),
                    //     roles: ['*'],
                    // }],
                    ['node', {
                        name: '请款节点',
                        display: isContrary != 1 && (((curRole == 'CRC' || curRole == 'CRCM' || curRole =='CRCC' ) && isMainPM) || (curRole !== 'CRC' && curRole !== 'CRCM' && curRole !=='CRCC' ) || curUserIsPm || isBoTal),
                        editable: true,
                        event: () => this.props.showNodeModel(record, isBoTal),
                        roles: ['VP', 'BO','FIN','PML','PM','BD','BDO','BDM','BA','BAL','CSA','CSAL', 'CRC', 'CRCC','CRCM'],
                    }],
                    ['noPaymentRequest', {
                        name: setNoPaymentRequest == 1 ? '取消标记为不请款' : '标记为不请款',
                        display: isContrary != 1 && (((curRole == 'CRC' || curRole == 'CRCM' || curRole =='CRCC' ) && isMainPM) || (curRole !== 'CRC' && curRole !== 'CRCM' && curRole !=='CRCC' ) || curUserIsPm || isBoTal),
                        editable: true,
                        event: () => this.setNoPaymentRequest(record),
                        roles: ['VP', 'BO','FIN','PML','PM','BD','BDO','BDM','BA','BAL','CSA','CSAL', 'CRC', 'CRCC','CRCM'],
                    }],
                    // ['log', {
                    //     name: '操作日志',
                    //     display: isContrary != 1,
                    //     editable: true,
                    //     event: () => this.props.showLog(record, 'CONTRACT_REMITTANCE_LOG'),
                    //     roles: ['*'],
                    // }],
                ]);
                return genOperationAuth(operationCorrespondRoles, curRole);
            })
        }];
    
        const getDataSource = () => {
            const { childJdeContractList } = this.state;

            let dataKey = 0;
            let key = 0;
            const dataSource = [];
            (childJdeContractList || []).forEach((dataItem, dataIndex) => {
                const { jdeContractSiteList = [], investigationJdeContractCode } = dataItem;
                if ((jdeContractSiteList || []).length) {
                    jdeContractSiteList.forEach((item, index) => {
                        dataSource.push({
                            index: index == 0 && ++key,
                            key: dataKey++,
                            ...dataItem,
                            rowSpan: index == 0 ? dataItem.mergeFlag : 0,
                            investigationSiteCode: item.investigationSiteCode,
                            investigationSiteName: item.investigationSiteName,
                        });
                    });
                } else {
                    dataSource.push({
                        index: !!investigationJdeContractCode ? ++key : '合计',
                        key: dataKey++,
                        ...dataItem,
                        rowSpan: 1,
                        investigationSiteCode: null,
                        investigationSiteName: null,
                    });
                }
            });
            return dataSource;
            
        };
    
        return (
            <Table
                rowKey={record => record.key}
                columns={getColumns}
                dataSource={getDataSource()}
                pagination={false}
                scroll={{x: 900, y: 380}}
                defaultExpandAllRows={true}
            />
        );
    }

    onExpand = (expanded, record) => {
        const { expandedRowKeys } = this.state;
        if (!expanded) {
            expandedRowKeys.splice(0, 1);
        } else {
            expandedRowKeys[0] = record.mainInvestigationJdeContractCode;
        }
        this.setState({ expandedRowKeys });
    }

    applyProjectFinish = (record, role) => {
        if (role === 'BA') {
            Modal.confirm({
                title: '确认申请此项目请款完成？',
                content: '确认后，将通知PM和财务进行请款完成确认操作。一旦全部确认，项目阶段将变更为“项目关闭”。',
                onOk: () => {
                    this.props.applyProjectFinish(record, role);
                }
            });
        } else {
            this.props.applyProjectFinish(record, role);
        }
    }

    applyContractFinish = (record, role) => {
        if (role === 'BA') {
            Modal.confirm({
                title: '确认申请此合同请款完成？',
                content: '确认后，将通知PM和财务进行请款完成确认操作。PM和财务确认此合同请款完成后，不可再为此合同进行请款。',
                onOk: () => {
                    this.props.applyContractFinish(record, role);
                }
            });
        } else {
            this.props.applyContractFinish(record, role);
        }
    }

    // 子合同 标记为不请款/取消标记为不请款
    setNoPaymentRequest = (record) => {
        const { investigationJdeContractId, setNoPaymentRequest } = record;
        const isMarked = setNoPaymentRequest == 1;
        Modal.confirm({
            title: isMarked ? '确认取消标记为不请款？' : '确认标记为不请款？',
            content: isMarked ? '取消后，此合同恢复为可请款状态。' : '标记后，此合同将不再进行请款。',
            onOk: () => {
                $.sendRequest({
                    url: API_URL.investigation.setNoPaymentRequest,
                    data: {
                        investigationJdeContractId,
                        setNoPaymentRequest: isMarked ? 0 : 1,
                    },
                    dataType: 'json',
                    doneResult: () => {
                        message.success(isMarked ? '取消标记为不请款成功' : '标记为不请款成功');
                        this.loadData();
                    },
                });
            }
        });
    }

    showProjectClose = (record, type) => {
        const { invJdeContractApplyColseConditions = [] } = record;
        if (type === 'apply') {
            if (invJdeContractApplyColseConditions.length !== 0) {
                const info = invJdeContractApplyColseConditions.map(
                    (el, index) => <div>{index + 1}、{el.message}。</div>
                );
                const target = invJdeContractApplyColseConditions[0].target;
                Modal.confirm({
                    title: '此项目暂不满足申请关闭条件。',
                    content: <div style={{ paddingRight: 30 }}>{info}</div>,
                    width: 600,
                    onOk: () => this.props.goToProcessing(target, record),
                    okText: '前往处理',
                });
            } else {
                Modal.confirm({
                    title: '确认申请此项目关闭？',
                    content: '确认后，将通知负责人和财务进行请款完成确认操作。一旦全部确认，项目阶段将变更为“项目关闭”。',
                    onOk: () => {
                        this.props.showProjectClose(record, type);
                    }
                });
            }
        } else {
            this.props.showProjectClose(record, type);
        }
    }

    render() {
        const { loading, pagination, data, expandedRowKeys } = this.state;
        return (
            <Table
                loading={loading}
                scroll={{x: 1200}}
                pagination={pagination}
                columns={this.getColumns()}
                dataSource={data}
                onChange={this.handleTableChange}
                rowKey={record => record.mainInvestigationJdeContractCode}
                expandedRowRender={this.expandedRowRender}
                expandedRowKeys={expandedRowKeys}
                onExpand={this.onExpand}
            />
        );
    }
}

export default Present;


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/Present.js